import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [recentPayments, setRecentPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        try {
            const response = await axios.get('http://localhost:5000/api/admin/dashboard-stats');
            if (response.data.success) {
                setStats(response.data.stats);
                setRecentPayments(response.data.recentPayments);
            }
        } catch (error) {
            console.error('Dashboard error:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading dashboard...</p>
        </div>
    );

    const handleLogout = () => {
        // remove token or session if stored
        localStorage.removeItem("token");

        // redirect to home page
        navigate("/");
    };


    return (

        <div className="admin-dashboard">
            <div className="dashboard-header">
                <div className="header-left">
                    <h1>
                        <span className="gradient-text">Dashboard</span>
                        <span className="header-badge">Admin</span>
                    </h1>
                    <p className="welcome-text">Welcome back! Here's what's happening with your payments today.</p>
                </div>
                <button className="logout-btn" onClick={handleLogout}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                    Logout
                </button>
            </div>

            <div className="stats-grid">
                <div className="stat-card revenue">
                    <div className="stat-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="12" y1="1" x2="12" y2="23" />
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                        </svg>
                    </div>
                    <div className="stat-content">
                        <h3>Total Revenue</h3>
                        <p className="stat-value">₹{stats?.totalRevenue?.toLocaleString() || 0}</p>
                        <span className="stat-trend positive">↑ 12% from last month</span>
                    </div>
                </div>
                <div className="stat-card payments">
                    <div className="stat-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                            <line x1="1" y1="10" x2="23" y2="10" />
                        </svg>
                    </div>
                    <div className="stat-content">
                        <h3>Total Payments</h3>
                        <p className="stat-value">{stats?.totalPayments || 0}</p>
                        <span className="stat-trend">Processed successfully</span>
                    </div>
                </div>
                <div className="stat-card links">
                    <div className="stat-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                        </svg>
                    </div>
                    <div className="stat-content">
                        <h3>Payment Links</h3>
                        <p className="stat-value">{stats?.totalLinks || 0}</p>
                        <span className="stat-trend">Total created</span>
                    </div>
                </div>
                <div className="stat-card active">
                    <div className="stat-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10" />
                            <polyline points="12 6 12 12 16 14" />
                        </svg>
                    </div>
                    <div className="stat-content">
                        <h3>Active Links</h3>
                        <p className="stat-value">{stats?.activeLinks || 0}</p>
                        <span className="stat-trend">Currently active</span>
                    </div>
                </div>
            </div>

            <div className="quick-actions">
                <h2>Quick Actions</h2>
                <div className="actions-grid">
                    <button className="action-card primary" onClick={() => navigate('/admin/create-payment-link')}>
                        <div className="action-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="16" />
                                <line x1="8" y1="12" x2="16" y2="12" />
                            </svg>
                        </div>
                        <div className="action-content">
                            <h3>Create Payment Link</h3>
                            <p>Generate a new payment link for customers</p>
                        </div>
                        <span className="action-arrow">→</span>
                    </button>
                    <button className="action-card secondary" onClick={() => navigate('/admin/payment-links')}>
                        <div className="action-icon">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
                                <line x1="8" y1="2" x2="8" y2="22" />
                                <line x1="16" y1="2" x2="16" y2="22" />
                                <line x1="2" y1="8" x2="22" y2="8" />
                                <line x1="2" y1="16" x2="22" y2="16" />
                            </svg>
                        </div>
                        <div className="action-content">
                            <h3>View All Links</h3>
                            <p>Manage and monitor all payment links</p>
                        </div>
                        <span className="action-arrow">→</span>
                    </button>
                </div>
            </div>

            <div className="recent-payments-section">
                <div className="section-header">
                    <h2>Recent Payments</h2>
                    {/* <button className="view-all-btn" onClick={() => navigate('/admin/payments')}>
                        View All
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="9 18 15 12 9 6" />
                        </svg>
                    </button> */}
                </div>

                <div className="table-container">
                    {recentPayments.length === 0 ? (
                        <div className="empty-state">
                            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1">
                                <rect x="2" y="4" width="20" height="16" rx="2" />
                                <path d="M2 8h20" stroke="#ccc" />
                            </svg>
                            <h3>No payments yet</h3>
                            <p>When customers make payments, they'll appear here</p>
                        </div>
                    ) : (
                        <table className="payments-table">
                            <thead>
                                <tr>
                                    <th>Transaction ID</th>
                                    <th>Customer</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    {/* <th>Actions</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {recentPayments.map((payment, index) => (
                                    <tr key={payment.txnid} className="table-row" style={{ animationDelay: `${index * 0.1}s` }}>
                                        <td>
                                            <span className="txn-id">
                                                {payment.txnid?.substring(0, 8)}...
                                                <button className="copy-txn" onClick={() => navigator.clipboard.writeText(payment.txnid)}>
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                                    </svg>
                                                </button>
                                            </span>
                                        </td>
                                        <td>
                                            <div className="customer-info">
                                                <div className="customer-avatar">
                                                    {payment.name?.charAt(0).toUpperCase()}
                                                </div>
                                                <span>{payment.name}</span>
                                            </div>
                                        </td>
                                        <td className="amount">₹{payment.amount?.toLocaleString()}</td>
                                        <td>
                                            <span className={`status-badge ${payment.payment_status}`}>
                                                {payment.payment_status}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="date">
                                                {new Date(payment.created_at).toLocaleDateString('en-US', {
                                                    month: 'short',
                                                    day: 'numeric',
                                                    year: 'numeric'
                                                })}
                                            </span>
                                        </td>
                                        <td>
                                            {/* <button className="action-btn view" onClick={() => navigate(`/admin/payment/${payment.txnid}`)}>
                                                View
                                            </button> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;